module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#premium",
      toString: function () {
        return this.url;
      }
    }